import React from 'react';
import PostPreview from './post-preview';

import { IPost } from '../models/post';
import { ITag } from '../models/tag';

interface IProps {
	posts: IPost[];
}

export default function AlsoRead({ posts }: IProps) {
	const getFirstTag = (tags: ITag) => {
		return tags?.edges[0]?.node?.name;
	};

	return (
		<section>
			<div className="grid grid-cols-1 md:grid-cols-2 gap-8">
				{posts.map(({ node }: IPost) => (
					<PostPreview
						key={node.slug}
						title={node.title}
						coverImage={node.featuredImage}
						date={node.date}
						slug={node.slug}
						excerpt={node.excerpt}
						badge={getFirstTag(node.tags)}
					/>
				))}
			</div>
		</section>
	);
}
